import DetailQuestion from "../components/DetailQuestion";
import PageContent from "../components/PageContent";
import classes from "./QuestionDetail.module.css";

function QuestionDetail() {
  // console.log("rendering QuestionDetail");
  let questions = JSON.parse(localStorage.getItem("questions"));
  let optionQuestions = questions?.optionQuestions;
  // console.log(questions);
  // console.log(optionQuestions);

  return (
    <PageContent>
      <div className={classes.content}>
        <h1>Detailed Analysis</h1>
        {optionQuestions?.map((item, index) => {
          return (
            <DetailQuestion
              id={`question${index}`}
              key={index}
              questionTitle={item.title}
              optionArr={item.options}
            />
          );
        })}

        <div className={classes.emptySpaceBelow}></div>
      </div>
    </PageContent>
  );
}

export default QuestionDetail;
